import React from "react";
import { motion } from "framer-motion";
import { CalendarCheck, ArrowRight } from "lucide-react";
import { useEnquiry } from "../context/EnquiryContext";

// Persistent, always-visible "Get Free Consultation" CTA across the entire site.
export default function FloatingConsult() {
  const { open, openEnquiry } = useEnquiry();

  return (
    <motion.button
      data-testid="floating-consultation-btn"
      onClick={() => openEnquiry("consultation", "floating")}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: open ? 0 : 1, y: open ? 24 : 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      style={{ pointerEvents: open ? "none" : "auto" }}
      className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[90] inline-flex items-center gap-2 rounded-full bg-terracotta text-warm pl-5 pr-5 md:pl-6 md:pr-6 py-3 md:py-3.5 text-xs md:text-sm font-medium shadow-xl shadow-navy/25 hover:bg-navy transition-colors"
    >
      <CalendarCheck size={16} className="shrink-0" />
      <span className="whitespace-nowrap">Get Free Consultation</span>
      <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
    </motion.button>
  );
}
